const state = {
  settingsData: [
    {
      id: 1,
      id_usuario: 1,
      name: 'info_lavanderia',
      value: '[{"nombreLavanderia":"Lavaexpress","telefono":"(322)-110-0853","direccion":"Revolución 304, Col. Bobadilla","ciudad":"Puerto Vallarta","estado":"Jalisco","pais":"México","codigoPostal":"48298","horaApertura":"08:00","horaCierre":"19:00"}]',
      context: ["tickets","configuracion"],
      description: 'Los datos del negocio',
      fecha: '2021-06-04 13:12:27'
    },
    {
      id: 2,
      id_usuario: 1,
      name: 'precio_dollar',
      value: 17.50,
      context: ["ventas","caja"],
      description: 'El precio del dólar para saber a cuanto tomarlo',
      fecha: '2021-06-04 13:12:28'
    }
  ],
};

const getters = {
  demoSettings: state => state.settingsData,
  demoLaundryInfo: state => state.settingsData.find(setting => setting.name == 'info_lavanderia'),
};

export default{
  state,
  getters
}